export const CHAT_ALERT_TIMEOUT = 4000;
export const OFFLINE_ALERT_TEXT =
  'Chat agent is currently offline. Try calling us or opening a ticket.';
